import { styled } from 'goober';

import { colors } from '@/theme/colors';
import { Icon } from '@/ui/icons/icon';
import { Stack } from '@/ui/line/line';
import { Tooltip } from '@/ui/tooltip/tooltip';

interface SpotlightInfoTooltipProps {
  dataTestId?: string;
  description: string;
  title: string;
}

export const SpotlightInfoTooltip = ({
  dataTestId,
  description,
  title,
}: SpotlightInfoTooltipProps) => (
  <Tooltip
    content={
      <Content gap="4px">
        <Title>{title}</Title>
        <Description>{description}</Description>
      </Content>
    }
    maxWidth="320px"
    padding="12px 16px"
    placement="bottom"
    withArrow={false}
  >
    <Trigger data-testid={dataTestId}>
      <Icon icon="Info" color={colors.gray.c11} />
    </Trigger>
  </Tooltip>
);

const Trigger = styled('span')`
  align-items: center;
  cursor: default;
  display: inline-flex;
  line-height: 0;
`;

const Content = styled(Stack)`
  text-align: left;
`;

const Title = styled('h6')`
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  margin: 0;
`;

const Description = styled('p')`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  margin: 0;
`;
